import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const ContactForm = lazy(
  () =>
    import('./ContactForm.eager').then(mod => ({
      default: mod.ContactForm,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
